module.exports = __webpack_public_path__ + "img/4-5.3be6ec50.svg";